import { Component } from '@angular/core'
import { MatDialogRef } from '@angular/material/dialog'

export interface DialogData {}

@Component({
  selector: 'cover-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss'],
})
export class ConfirmModalComponent {
  constructor(public dialogRef: MatDialogRef<ConfirmModalComponent>) {}

  onClickCloseOrCancel(): void {
    this.dialogRef.close()
  }
}
